
import { versionUtils } from '@src/corelib/utils';

import { resolveApiBase, resolveAuthBase, resolveSiteBase } from './apiBase';

// Device mode (`make device-*`) launches Vite with EMPTY VITE_API_DOMAIN/
// VITE_AUTH_DOMAIN so the SPA talks to its own origin and the Vite `/api` +
// `/metadata` proxy reaches the backend (no CORS on the device). Default localhost/
// prod set these to an absolute host and behave exactly as before. `origin` is the
// same-origin fallback used only when the domain env is empty.
const apiDomain = import.meta.env.VITE_API_DOMAIN;
const authDomain = import.meta.env.VITE_AUTH_DOMAIN;
const origin = typeof window !== 'undefined' ? window.location.origin : '';
const authBase = resolveAuthBase({ authDomain, origin });

function Settings({ DEBUG }) {
  // Main
  this.DEBUG = DEBUG;

  // Authentification
  this.AUTH = {
    JWT: {
      USERNAME_FIELD: 'email',
      PASSWORD_FIELD: 'password',
      ACCESS_TOKEN_FIELD: 'access',
      REFRESH_TOKEN_FIELD: 'refresh',
      AUTH_DOMAIN: authDomain,
      TOKEN_CREATE_URL: `${authBase}/jwt/token/create/`,
      TOKEN_VERIFY_URL: `${authBase}/jwt/token/verify/`,
      TOKEN_REFRESH_URL: `${authBase}/jwt/token/refresh/`,
      EXPIRED_BUFFER: 1000 * 60 * 5, // 5 minutes
    },
    GOOGLE: {
      // Public web client id (safe in the bundle). Secrets must never be VITE_* vars.
      CLIENT_ID: import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID || '',
    },
  };

  this.CLIENTS = {
    origin: {
      baseURL: resolveApiBase({ apiDomain, origin }),
    },
    // Site-root base (no /api/v1 prefix) for the few endpoints mounted at the
    // Django site root rather than under the versioned API — e.g. the metadata
    // options reference endpoint (`GET /metadata/options/`). Used as a per-request
    // axios `baseURL` override on the shared origin client. Kept absolute in device
    // mode (same-origin) so the full URL still bypasses the /api/v1 client baseURL.
    site: {
      baseURL: resolveSiteBase({ apiDomain, origin }),
    },
  };


  this.init = () => {
    const version = versionUtils.getAppVersion();
    console.info(`Init | App - ${version}`);

    if (this.DEBUG) {
      console.info('Init | Settings - Development.');
    }
    else {
      console.info('Init | Settings - Production.');
    }
  };
}

function getSettings() {
  if (import.meta.env.MODE === 'production') {
    return new Settings({ DEBUG: false });
  }
  return new Settings({ DEBUG: true });
}

const settings = getSettings();

export default settings;
